import LayoutGerenciadorContent from "./content";
import LayoutGerenciadorHeader from "./header";
import LayoutGerenciadorRoot from "./root";

export const GerenciadorLayout = {
  Root: LayoutGerenciadorRoot,
  Header: LayoutGerenciadorHeader,
  Content: LayoutGerenciadorContent,
};
